import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Router} from '@angular/router';
import {ServiceConfig} from './service-config';
import {HttpClient} from '@angular/common/http';
@Injectable()
export class AccessTokenService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/token/';
  // public baseUrl = 'http://localhost/api/account/';
  private data: any;
  private headers: Headers;
  private options: {};

  constructor(private http: HttpClient,
              private router: Router) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
    this.options = {headers: this.headers};
  }

  public index() {
    let url = this.baseUrl + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }
  public create(body) {
    let url = this.baseUrl + '/create?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public update(body) {
    let url = this.baseUrl + '/update?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public delete( body) {
    let url = this.baseUrl +  '/delete?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }
  
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/access-token.service.ts